import styled from 'styled-components/macro';
import {useState} from "react";
import {
    Button,
    Checkbox,
    FormControl,
    FormErrorMessage,
    FormHelperText,
    FormLabel,
    Input,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    Stack,
    Textarea,
    useToast
} from "@chakra-ui/react";
import {useFeedback} from "../store/feedback";
import {useSaveFeedSettings} from "../api/custom_feeds";
import {useActions} from "../store";

const FeedSettings = styled(({currentFeed, handleUpdate, onClose}) => {
    const {error, feedbackCh} = useFeedback();
    const [feed, setFeed] = useState({
        name: currentFeed.feed_name,
        description: currentFeed.description,
        isPublic: currentFeed.is_public,
    });
    const set = (name) => (value) => setFeed((feed) => ({...feed, [name]: value}));

    const [logo, setLogo] = useState(null);
    const toast = useToast();

    const [saving, setSaving] = useState(false);
    const actions = useActions();

    const saveSettings = useSaveFeedSettings(feedbackCh);
    const handleSave = async () => {
        if (saving) return;
        try {
            setSaving(true);
            const {feeds} = await saveSettings(currentFeed.id, feed, logo ? logo : '');
            currentFeed = feeds[0];
            actions.savedFeedsUpdated(feeds[0]);
            handleUpdate(feed.name, feed.description);
                onClose();
            toast({
                title: `Saved updated for this feed!`,
                status: 'success',
                isClosable: true,
            });
        } catch {
            // error is displayed
        }
        setSaving(false);
    };

    return (
        <>
            <Modal
                isOpen
                onClose={onClose}
                size={'xl'}
            >
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>Feed Settings</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody pb={6}>

                        <Stack spacing={'5'}>

                                    <FormControl>
                                        <FormLabel>Feed Name</FormLabel>
                                        <Input placeholder="Cats" value={feed.name}
                                               onChange={(e) => set('name')(e.currentTarget.value)}/>
                                    </FormControl>

                                    <FormControl>
                                        <FormLabel>Describe your feed.</FormLabel>
                                        <Textarea placeholder="A feed which only contains cats."
                                                  value={feed.description}
                                                  onChange={(e) => set('description')(e.currentTarget.value)}/>
                                        <FormHelperText>Recommended if your feed is public.</FormHelperText>
                                    </FormControl>

                                    <FormControl>
                                        <Checkbox size='sm' isChecked={feed.isPublic}
                                                  onChange={(e) => set('isPublic')(e.target.checked)}>Allow other users
                                            to find and use this feed.</Checkbox>
                                    </FormControl>

                                    <FormControl isInvalid={error}>
                                        <FormErrorMessage>{error?.toString()}</FormErrorMessage>
                                    </FormControl>


                        </Stack>

                    </ModalBody>

                    <ModalFooter>
                        <Button variant="cancel" mr={3} onClick={onClose}>Cancel</Button>
                        <Button variant="blue" isLoading={saving} onClick={handleSave}>
                            Save
                        </Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>
        </>
    )
})``;

export default FeedSettings;
